import type { LoadableComponent } from '@loadable/component';
import loadable from '@loadable/component';
import React from 'react';

import { useCuration } from '@hooks/useCuration';
import { useSession } from '@hooks/useSession';

const VitallDashboard = loadable(
  () => import('@views/Dashboard/VitallDashboard')
);
const PractitionerDashboard = loadable(
  () => import('@views/Dashboard/PractitionerDashboard')
);
const ClientDashboard = loadable(
  () => import('@views/Dashboard/ClientDashboard')
);

export default function DashboardPage() {
  const {
    state: { isOrg, isVitall },
  } = useSession();
  const {
    state: { patientView },
  } = useCuration();

  let Dashboard: LoadableComponent<unknown>;
  if (isOrg && !patientView) {
    Dashboard = PractitionerDashboard;
  } else if (isVitall && !patientView) {
    Dashboard = VitallDashboard;
  } else {
    Dashboard = ClientDashboard;
  }

  return <Dashboard />;
}
